import styled from 'styled-components'
import CarouselTicketBg from 'assets/png/carousel_ticket_bg1.svg'
import CarouselTicketBg2 from 'assets/png/carousel_ticket_bg2.svg'

export const Container = styled.div<{
  $scale: number
}>`
  ${({ $scale }) =>
    $scale === 100 &&
    `background-image: url('data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzEyIiBoZWlnaHQ9IjQ5NCIgdmlld0JveD0iMCAwIDMxMiA0OTQiIGZpbGw9Im5vbmUiIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CjxwYXRoIGQ9Ik0yODkuNTE0IDEuNDY2NTZlLTA1QzMwMS45MzIgMS41MzUwNmUtMDUgMzEyIDEyLjcwMzEgMzEyIDI4LjM3MzFMMzEyIDQ2NS42MjdDMzEyIDQ4MS4yOTcgMzAxLjkzMiA0OTQgMjg5LjUxNCA0OTRIMjA5LjU3OUMxOTguNjM2IDQ3Ny4wODkgMTc5LjQ4MSA0NjUuODggMTU3LjY4IDQ2NS44OEMxMzUuODc5IDQ2NS44OCAxMTYuNzI0IDQ3Ny4wODkgMTA1Ljc4MiA0OTRIMjIuNDg2NUMxMC4wNjc2IDQ5NCAtNS40Mjg0OWUtMDcgNDgxLjI5NyAwIDQ2NS42MjdMMi4yNzEyNGUtMDUgMjguMzczMkMyLjMyNTUyZS0wNSAxMi43MDMxIDEwLjA2NzYgLTYuODQ5NTllLTA3IDIyLjQ4NjUgMEwxMDUuNzgxIDUuODY2MjRlLTA2QzExNi43MjQgMTYuOTEwOCAxMzUuODc5IDI4LjExOTggMTU3LjY4IDI4LjExOThDMTc5LjQ4MSAyOC4xMTk4IDE5OC42MzYgMTYuOTEwOCAyMDkuNTc5IDEuMTczMjVlLTA1TDI4OS41MTQgMS40NjY1NmUtMDVaIiBmaWxsPSIjRUE3MTAwIi8+Cjwvc3ZnPgo=')`};

  ${({ $scale }) => $scale === 300 && `background-image: url(${CarouselTicketBg2})`};

  ${({ $scale }) => $scale === 400 && `background-image: url(${CarouselTicketBg2})`};

  ${({ $scale }) => $scale === 500 && `background-image: url(${CarouselTicketBg})`};

  background-position: top center;
  background-repeat: no-repeat;
  background-size: contain;
  transition: all 0.5s ease;
`
